export default "__VITE_ASSET__D4k6JEgJ__"